import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { fadeInUp } from "../utils/motion";

function AnimatedCounter({ value, label, suffix = "" }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1700;
    const stepTime = Math.max(20, Math.floor(duration / value));
    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start >= value) {
        clearInterval(timer);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <motion.div
      variants={fadeInUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.4 }}
      className="glass rounded-xl p-5 text-center shadow-glass"
    >
      <p className="text-3xl font-bold text-cyan-300">
        {count}
        {suffix}
      </p>
      <p className="mt-2 text-sm uppercase tracking-[0.15em] text-blue-100/70">
        {label}
      </p>
    </motion.div>
  );
}

export default AnimatedCounter;
